import React from "react";

import styles from "./User.module.css";
import AuthContext from "../../contexts/AuthContext";
import { A, navigate } from "hookrouter";
import cogoToast from "cogo-toast";
import firebase from "firebase/app";
import "firebase/firestore";
import { FaComment } from "react-icons/fa";
import { AppContext } from "../../contexts/AppContext";
import { FaEdit } from "react-icons/fa";
import { FaRegCheckSquare } from "react-icons/fa";
import UserAvatarEditor from "./UserAvatarEditor";
import api from "../../actions/common";

const ProfileInfo = ({ user, followers, readingListCount, storiesCount, loadData, updateFollowers }) => {
  const currentUser = React.useContext(AuthContext).user;
  const isCurrentUser = currentUser._id === user._id;
  const { token } = React.useContext(AuthContext);
  const { setChat } = React.useContext(AppContext);
  const [alreadyFollowing, setAlreadyFollowing] = React.useState(false);
  const [coverImage, setCoverImage] = React.useState(user.cover_photo);
  const inputCoverRef = React.useRef();
  const [loading, setLoading] = React.useState(false);
  const [editAvatar, setEditAvatar] = React.useState(false);
  const [avatarImageEditor, setAvatarImageEditor] = React.useState(null);


  const handleChange = (e) => {
    if (!e.target.files[0]) return;
    console.log(e.target.files[0]);
    setCoverImage(URL.createObjectURL(e.target.files[0]));
    const blob = new Blob([e.target.files[0]], { type: "image/jpeg" });
    uploadCoverImage(blob);
  };

  const uploadCoverImage = async (blob) => {
    var formdata = new FormData();
    formdata.append('cover_photo', blob);
    const resp = await api.put('/users/uploadCover', token, formdata, setLoading);
    if (resp.success || resp.status) {
      cogoToast.success("Successfully updated cover image");
    } else {
      if (resp.message) {
        cogoToast.error(resp.message);
      } else {
        cogoToast.error("Something Went Wrong");
      }
    }
  };

  const uploadAvatarImage = async (blob) => {
    var formdata = new FormData();
    formdata.append('bio', user.bio);
    formdata.append('avatar_link', blob);

    const resp = await api.put('/users/updateProfile', token, formdata, setLoading);
    console.log(resp);

    if (resp.success || resp.status) {
      cogoToast.success("Successfully updated profile image");
      setEditAvatar(false);
      loadData();
    } else {
      if (resp.message) {
        cogoToast.error(resp.message);
      } else {
        cogoToast.error("Something Went Wrong");
      }
    }
  };

  const submitAvatarImage = () => {
    if (avatarImageEditor && avatarImageEditor.current) {
      avatarImageEditor.current.getImage().toBlob((blob) => uploadAvatarImage(blob));
    } else {
      cogoToast.error("Please add an image");
    }
  };

  const unfollowAuthor = () => {
    (async () => {
      const rawResponse = await fetch(
        "https://api.yazbie.com/api/follow/unfollow",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({ userId: user._id }),
        }
      );
      try {
        let content = await rawResponse.clone().json();
        if (content && content.success) {
          cogoToast.success(content.message);
          checkFollowing();
          updateFollowers();
        } else if (content && !content.success) {
          cogoToast.error(content.message);
        }
      } catch (err) {
        console.log(err);
        console.log(await rawResponse.clone().text());
      }
    })();
  };

  const followAuthor = () => {
    (async () => {
      const rawResponse = await fetch(
        "https://api.yazbie.com/api/follow/startFollowing",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({ userId: user._id }),
        }
      );
      try {
        let content = await rawResponse.clone().json();
        console.log(content);
        if (content && content.success) {
          cogoToast.success(content.message);
          checkFollowing();
          updateFollowers();
        } else if (content && !content.success) {
          cogoToast.error(content.message);
        }
      } catch (err) {
        console.log(err);
        console.log(await rawResponse.clone().text());
      }
    })();
  };

  const checkFollowing = () => {
    (async () => {
      const rawResponse = await fetch("https://api.yazbie.com/api/follow", {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token,
        },
      });
      try {
        let content = await rawResponse.clone().json();
        console.log(content);
        if (content && content.success) {
          setAlreadyFollowing(
            content.followings.filter((x) => x.userId === user._id).length === 1
          );
        } else if (content && !content.success) {
          // cogoToast.error(content.message);
        }
      } catch (err) {
        console.log(err);
        console.log(await rawResponse.clone().text());
        // cogoToast.error(await rawResponse.clone().text());
      }
    })();
  };

  const startChat = () => {
    const db = firebase.firestore();
    db.collection("chat")
      .where("users", "array-contains", currentUser._id)
      .get()
      .then((ch) => {
        const chats = ch.docs.map((d) => d.data());
        // console.log(chats);
        // console.log(chats.filter((u) => u.users.includes(user._id)));
        if (chats.filter((u) => u.users.includes(user._id)).length === 0) {
          console.log("c");
          db.collection("chat")
            .add({
              users: [user._id, currentUser._id],
            })
            .then(() => setChat(true));
        } else {
          console.log("d");
          setChat(true);
        }
      });
  };

  React.useEffect(() => {
    checkFollowing();
  }, []);

  return (
    <div
      className={styles.header}
      style={{ backgroundImage: `url(${coverImage})` }}
    >
      <div className={styles.overlay}>
        {isCurrentUser && <button className={styles.headerEdit} onClick={() => inputCoverRef.current.click()}>Edit <FaEdit /></button>}
        <input
          className={styles.imagePicker}
          type="file"
          id="coverImage"
          ref={inputCoverRef}
          onChange={handleChange}
        />
      </div>
      <div className={styles.content}>
        <div
          className={styles.avatar}
          style={{
            backgroundImage: `url(${user.avatar_link}), url("https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fcdn.iconscout.com%2Ficon%2Ffree%2Fpng-256%2Favatar-370-456322.png&f=1&nofb=1)`,
          }}
        >
          {isCurrentUser && !editAvatar && <button className={styles.avatarEdit} onClick={() => setEditAvatar(true)}><FaEdit /></button>}
          {editAvatar && <UserAvatarEditor
            imageEditor={avatarImageEditor}
            setImageEditor={setAvatarImageEditor}
          />}
          {isCurrentUser && editAvatar && avatarImageEditor && <button className={styles.avatarEdit} onClick={submitAvatarImage}><FaRegCheckSquare /></button>}
        </div>
        <h3>{user.name}</h3>
        {isCurrentUser ? (
          <div></div>
        ) : alreadyFollowing ? (
          <div className={styles.buttons}>
            <button onClick={unfollowAuthor}>Unfollow</button>
            <button onClick={startChat}>
              <FaComment />
            </button>
          </div>
        ) : (
              <div className={styles.buttons}>
                <button onClick={followAuthor}>Follow</button>
                <button onClick={startChat}>
                  <FaComment />
                </button>
              </div>
            )}

        <div className={styles.stats}>
          <div className={styles.stat}>
            <h3>{storiesCount}</h3>
            <p>Stories</p>
          </div>
          <div className={styles.stat}>
            <h3>{readingListCount}</h3>
            <p>Reading Lists</p>
          </div>
          <div className={styles.stat}>
            <h3>{followers && followers.length}</h3>
            <p>Followers</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileInfo;
